module.exports = __webpack_public_path__ + "img/nevada.bdbd0075.png";